import { discountsTableHeader } from '../../../../assets/helpers/tables';
import useDiscount from '../../../../hooks/params/useDiscount';
import { ActionButton } from '../../../common/Buttons/Buttons';
import { LandingDiiscountTable } from '../../../common/Tables/Tables';
import { itemsPerPageOptions } from '../parametersConstants';
import SurchargesForm from './DiscountForm';

export default function DiscountsParametersSection() {
  const {
    register,
    errors,
    showDiscountForm,
    setShowDiscountForm,
    discountData,
    editDiscountId,
    handleDiscountPageChange,
    handleToggleDiscountActive,
    handleEditDiscount,
    onSubmit,
    onDiscountSelectPerPage,
    inactiveDiscount,
    closeForm,
    setValue,
    getValues,
    control,
    clearErrorByFieldName,
    getActiveCodes,
    listActiveCodes
  } = useDiscount();
  return (
    <>
      <div className="parameters-page__pills-row" style={{ justifyContent: 'flex-end'}}>
        <ActionButton
          type="button"
          action={() => setShowDiscountForm((s) => !s)}
          label={'+ Nueva campaña'}
        />
      </div>
      <LandingDiiscountTable
        header={discountsTableHeader}
        data={discountData}
        handlePageChange={handleDiscountPageChange}
        onToggleActive={handleToggleDiscountActive}
        onEdit={handleEditDiscount}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onDiscountSelectPerPage}
        inactiveCount={inactiveDiscount}
      />
    <SurchargesForm
        isOpen={showDiscountForm}
        onClose={closeForm}
        onSubmit={onSubmit}
        register={register}
        errors={errors}
        editingDiscountId={editDiscountId}
        setValue={setValue}
        getValues={getValues}
        control={control}
        clearErrorByFieldName={clearErrorByFieldName}
        getActiveCodes={getActiveCodes}
        listActiveCodes={listActiveCodes}
    />
    </>
  );
}
